import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import Input from "../../../../common/FormComponents/Input";
import Select from "../../../../common/FormComponents/Select";
import FormSectionHeader from "../../../../common/Form/FormSectionHeader";
import FormSectionGrid from "../../../../common/Form/FormSectionGrid";

const AddressInfo = ({
  control,
  errors,
  pageText,
  lookupDropdownData,
}: any) => {
  return (
    <Box id="AddressInfo">
      <FormSectionHeader>
        {pageText?.labelsMetadata?.addressInformation}
      </FormSectionHeader>
      <FormSectionGrid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="address"
            type="text"
            control={control}
            placeholder={`${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.addressLabel}`}
            errors={errors}
            label={`${pageText?.labelsMetadata.addressLabel} *`}
            rules={{
              required: `${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.addressLabel}`,
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="addressLine2"
            type="text"
            control={control}
            placeholder={`${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.addressLabel2}`}
            errors={errors}
            label={`${pageText?.labelsMetadata.addressLabel2} *`}
            rules={{
              required: `${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.addressLabel2}`,
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="addressLine4"
            type="text"
            control={control}
            placeholder={`${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.addressLabel4}`}
            errors={errors}
            maxLength={20}
            label={`${pageText?.labelsMetadata.addressLabel4} *`}
            rules={{
              required: `${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.addressLabel4}`,
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="city"
            type="text"
            control={control}
            placeholder={`${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.addressLabel3}`}
            errors={errors}
            label={`${pageText?.labelsMetadata?.addressLabel3} *`}
            rules={{
              required: `${pageText?.validationMessages.pleaseEnter} ${pageText?.labelsMetadata.addressLabel3}`,
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Select
            label={`${pageText?.labelsMetadata.countryLabel} *`}
            classNamePrefix={"form_drop"}
            placeholder={`- ${pageText?.labelsMetadata?.selectText} -`}
            options={lookupDropdownData?.countries}
            control={control}
            errors={errors}
            name="country"
            rules={{
              required: {
                value: true,
                message: pageText?.validationMessages.pleaseSelectCountry,
              },
            }}
          />
        </Grid>
      </FormSectionGrid>
    </Box>
  );
};

export default AddressInfo;
